import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LangWrapper = ({ children }) => {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  
  const allowedLanguages = ['fr', 'en', 'it', 'de', 'es'];

  useEffect(() => {
    if (lang && allowedLanguages.includes(lang) && lang !== i18n.language) {
      // If language is specified in URL, use it
      console.log('🔄 Using URL language:', lang);
      i18n.changeLanguage(lang);
    } else if (!lang) {
      // If no language in URL, detect from browser
      console.log('🌐 No URL language, detecting from browser...');
      
      // Get browser language and find the best match
      const browserLang = navigator.language || navigator.languages?.[0] || 'en';
      const browserLangCode = browserLang.split('-')[0]; // 'en-GB' -> 'en'
      
      console.log('🌍 Browser language detected:', browserLang, '->', browserLangCode);
      
      if (allowedLanguages.includes(browserLangCode) && browserLangCode !== i18n.language) {
        console.log('🔄 Using browser language:', browserLangCode);
        i18n.changeLanguage(browserLangCode);
      } else if (!allowedLanguages.includes(browserLangCode)) {
        console.log('🇫🇷 Browser language not supported, defaulting to French');
        i18n.changeLanguage('fr');
      } else {
        console.log('✅ Already using correct language:', i18n.language);
      }
    }
  }, [lang, i18n]);

  return children;
};

export default LangWrapper;
